import Page from './page';
import mapDataToState from './mapper';
import renderApp from '../../index';

export default renderApp({ Page, mapDataToState });
